/**
 * Strip Markdown formatting to a clean plain-text string suitable for the
 * browser Notification API body, which renders no HTML and treats Markdown
 * markers as literal characters. Targets the small subset of Markdown the
 * agent emits: paragraphs, bold/italic, code spans, code fences, lists,
 * blockquotes, headings, links.
 */
export function markdownToPlain(
  value: string | null | undefined,
  maxLength = 180
): string {
  if (!value) return ''

  let text = value
    .replace(/```[\s\S]*?```/g, (block) =>
      block
        .replace(/^```[^\n]*\n?/, '')
        .replace(/```\s*$/, '')
        .trim()
    )
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/^\s*>\s?/gm, '')
    .replace(/^\s*[-*+]\s+/gm, '- ')
    .replace(/^\s*\d+\.\s+/gm, (m) => m.trim() + ' ')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/__([^_]+)__/g, '$1')
    .replace(/(^|[^*])\*([^*\n]+)\*/g, '$1$2')
    .replace(/(^|[^_])_([^_\n]+)_/g, '$1$2')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')

  text = text
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim()

  if (text.length > maxLength) {
    text = text.slice(0, Math.max(0, maxLength - 1)).trimEnd() + '\u2026'
  }

  return text
}
